var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',{staticClass:"quantity-bg",attrs:{"src":require(`../../../../assets/icons/dashboard/quantities/${_vm.code}_${_vm.theme}.svg`)}})
}
var staticRenderFns = []

export { render, staticRenderFns }